import { Reservation } from "redmond";
import { BookingCompleteData } from "@capone/common";

export const buildHotelBookingData = (
  reservation: Reservation,
): BookingCompleteData => ({
  earnedRewards: { value: 0, currency: "Miles" },
  booking: {
    type: "hotel",
    itineraryId: reservation.reservationBookingId,
    name: reservation.lodgingData.name,
    imageUrl: reservation.lodgingData.media[0]?.url ?? "",
    checkInDate: reservation.checkInDate,
    checkOutDate: reservation.checkOutDate,
    guestCount: reservation.guests.length,
    roomCount: reservation.bookedRooms.reduce(
      (sum, room) => sum + room.count,
      0,
    ),
  },
});
